import { Fragment } from 'react';

const XeroBusiness2CloudConnectorConfiguration = ({ configuration }: any) => <Fragment />;

export default XeroBusiness2CloudConnectorConfiguration;
